/// <reference path="../../typings/browser.d.ts" />

namespace Application.Directives {
    'use strict';

    /**
     * Factory callback type
     */
    declare type ChecksDirectiveFactoryCb = (modalService: ngModal.IModalService) => ChecksDirective;

    /**
     * Custom scope
     */
    export interface IChecksDirectiveScopeDef {
        model: string;
        disableFloating: string;
        id: string;
        disabled: string;
    }

    /**
     * Custom scope
     */
    export interface IChecksDirectiveScope extends ng.IScope {
        model: Models.ITopologyElement;
        disableFloating: boolean;
        id: string;
        disabled: boolean;
        editChecks: () => void;
    }

    /**
     * Bar directive
     */
    export class ChecksDirective implements ng.IDirective {
        public static $name: string = "checks";

        public link: (scope: IChecksDirectiveScope, element: JQuery, attrs: ng.IAttributes) => void;
        public restrict: string = 'E';
        public replace: boolean = true;
        public transclude: boolean = false;
        public templateUrl: string = 'decorators/checks-directive.html';
        public scope: IChecksDirectiveScopeDef = {
            model: '=',
            disableFloating: '@',
            id: '@',
            disabled: '@',
        };

        /**
         * Factory for the directive
         */
        public static Factory(): ChecksDirectiveFactoryCb {
            let directive: ChecksDirectiveFactoryCb = (modalService: ngModal.IModalService) => {
                return new ChecksDirective(modalService);
            };
            directive.$inject = ['ModalService'];
            return directive;
        }

        /**
         * Constructor
         */
        constructor(modalService: ngModal.IModalService) {
            ChecksDirective.prototype.link = (scope: IChecksDirectiveScope, element: JQuery, attrs: ng.IAttributes) => {
                scope.editChecks = () => {
                    modalService.showModal({
                        templateUrl: Application.Controllers.HealthChecksModalController.templateURL,
                        controller: Application.Controllers.HealthChecksModalController.$name,
                        inputs: {
                            networkElement: scope.model,
                        },
                    }).then((modal: ngModal.IModalObject) => {
                        let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.HealthChecksModalController.ID,
                                    {bgclose: false, modal: false, keyboard: false});
                        modalElem.show();
                        modal.close.then(() => {
                            modalElem.hide();
                        });
                    });
                };
            };
        }
    }
}
